module.exports = __webpack_public_path__ + "static/media/OneSmartSheepJacket.61557b91.jpg";